import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectTimesheetEntryValue } from '../../../../../../../../../../services/timesheetEntries/selectors';

interface Props {
    units?: ?number;
}

export class TimesheetEntryUnits extends React.PureComponent<Props> {
    render() {
        const { units } = this.props;
        if (!units) return null;
        return units;
    }
}

const mapStateToProps = createStructuredSelector({
    units: makeSelectTimesheetEntryValue('units')
});

export default connect(mapStateToProps)(TimesheetEntryUnits);
